export default class ScrollTo {
    static init(): void {
        this.handleAnchors();
        this.urlAnchors();
    }

    static handleAnchors(): void {
        if (document.body.classList.contains('js-technology-page')) {
            const anchors = document.querySelectorAll('.js-scroll-to');

            anchors.forEach((anchor) => {
                anchor.addEventListener('click', (e) => {
                    e.preventDefault();
    
                    const navbar = document.querySelector('.navbar');
                    const navbarBottom = navbar?.querySelector('.navbar-desktop__menu-bottom');
                    const navbarHeight = navbar?.clientHeight || 0;
                    const navbarBottomHeight = navbarBottom?.clientHeight || 0;
    
                    let targetHref = anchor.getAttribute('href');
                    if (!targetHref) return;
                    targetHref = targetHref.replace('/', '');
                    const target = document.querySelector(targetHref);
                    if (!target) return;
    
                    const targetTop = target.getBoundingClientRect().top + window.scrollY;
                    const targetPosition = targetTop - navbarHeight - navbarBottomHeight;
    
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                });
    
            });
        }
    }

    static urlAnchors(): void {
        if (document.body.classList.contains('contact-page')) {
            // Odebrání hash z URL
            const originalHash = window.location.hash;
            history.replaceState(null, '', window.location.pathname + window.location.search);

            setTimeout(() => { // Zpoždění skrolování, aby se stránka stihla načíst
                const checkHashAndScroll = () => {
                    if (originalHash) {
                        const targetElement = document.querySelector(originalHash);
                        const navbarHeight = document.querySelector('.navbar')?.clientHeight ?? 0;

                        if (targetElement) {
                            const offsetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - navbarHeight;

                            window.scrollTo({
                                top: offsetPosition,
                                behavior: 'smooth'
                            });

                            // Vrácení původního hash do URL
                            history.replaceState(null, '', window.location.pathname + window.location.search + originalHash);
                        }
                    }
                };

                checkHashAndScroll(); // Vyvolá funkci po zpoždění
            }, 100); // Zpoždění v milisekundách, nastavte podle potřeby
        }
    }
}
